<!--
  Created 17.01.2023
  Originated from Tailwind UI component: Overlays, CenteredWithSingleAction
  https://tailwindui.com/components/application-ui/overlays/modals#component-31555aec01de5027d6696629eb60f673
-->
<template>
  <TransitionRoot
    as="template"
    :show="loading">
    <Dialog
      as="div"
      class="relative z-50"
      >
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
              <div>
                <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                  <span class="animate-spin">
                    <ArrowPathIcon
                      class="h-6 w-6 text-green-600"
                      aria-hidden="true" />
                  </span>
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle
                    as="h3"
                    class="text-lg font-medium leading-6 text-gray-900">
                    {{ heading }}
                  </DialogTitle>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      {{ paragraph }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6">
                <Link
                  v-if="button.route !== 'back'"
                  :href="button.route">
                  <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md border border-transparent bg-gray-600 px-4 py-2
                    text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2
                    focus:ring-gray-500 focus:ring-offset-2 sm:text-sm">
                    {{ button.text }}
                  </button>
                </Link>
                <button
                  v-else
                  type="button"
                  class="inline-flex w-full justify-center rounded-md border border-transparent bg-gray-600 px-4 py-2
                    text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2
                    focus:ring-gray-500 focus:ring-offset-2 sm:text-sm"
                  @click="back()">
                  {{ button.text }}
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
'
'<script setup>
import { Link } from '@inertiajs/vue3';
import {
  Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot,
} from '@headlessui/vue';
import { ArrowPathIcon } from '@heroicons/vue/24/outline';

function back() {
  if (window.history.length && window.history.length > 2) {
    return window.history.back();
  }
}

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
    required: true,
  },
  heading: {
    type: String,
    default: 'Loading',
    required: false,
  },
  paragraph: {
    type: String,
    default: 'Give us a few seconds while we fetch all the bits and pieces for you',
    required: false,
  },
  button: {
    type: Object,
    required: false,
    default: () => {
      if (window.history.length && window.history.length > 2) {
        return ({
          text: 'Go back',
          route: 'back',
        });
      }

      return ({
        text: 'Go to dashboard',
        route: '/dashboard',
      });
    },
  },
});

</script>
